@if (achievements().length === 0) {
  <p class="text-sm text-dusk">No achievements configured yet.</p>
} @else {
  <ul class="flex flex-col gap-3">
    @for (achievement of achievements(); track achievement.id) {
      <li class="rounded border border-hairline px-4 py-3">
        <div class="flex items-start justify-between gap-4">
          <div>
            <span class="text-sm font-semibold text-parchment">{{ displayName(achievement) }}</span>
            @if (displayDescription(achievement); as description) {
              <p class="mt-1 text-xs text-dusk">{{ description }}</p>
            }
          </div>
          <span class="shrink-0 text-right text-xs font-semibold text-gold">
            @if (achievement.awardType === 'POINTS') {
              @if (achievement.pointsValue !== null) {
                {{ achievement.pointsValue }} pts
              } @else {
                Split points
              }
            } @else {
              {{ achievement.prizeDescription ?? 'Prize' }}
            }
          </span>
        </div>
      </li>
    }
  </ul>
}
